export const SET_ERROR_LIST = "SET_ERROR_LIST";
export const CLEAR_ERROR_LIST = "CLEAR_ERROR_LIST";
export const CLEAR_ERROR_ELEMENTS_LIST = "CLEAR_ERROR_ELEMENTS_LIST";
export const SET_ERROR_DETAIL_LIST = "SET_ERROR_DETAIL_LIST";
export const SHOW_ERROR_DETAILS = "SHOW_ERROR_DETAILS";
